import { useTexts } from '@/feature/lang';
import type { Column } from '@tanstack/react-table';
import { useDataProvider } from '../DataProviderContext';
import type { Option } from '../types';

const NO_OPTIONS: Option[] = [];

export const useOptions = (column: Column<any> | undefined): Option[] => {
  const { table } = useDataProvider();
  const texts = useTexts();

  if (
    table === undefined ||
    column === undefined ||
    typeof column.columnDef.meta?.options !== 'function'
  ) {
    return NO_OPTIONS;
  }
  return column.columnDef.meta.options({ texts, table });
};
